import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Button,
  InfoCardNewAdv,
  LogoLoader,
  Modal,
  showToast,
  SmartTooltip,
  TableAdv,
} from "../../../../components";
import { usePagination } from "../../../../hooks";
import { dateFormator, mapTableRows } from "../../../../utils";
import InvoiceDetails from "../../Invoices/Invoices/InvoiceDetails";
import { getCurrentInvoiceStart } from "../../../../redux/slices/invoices/invoicesSlice";
import { useDispatch } from "react-redux";
import { fetchAllInvoices } from "../../../../redux/slices/invoices/invoicesApi";
import { getTotalCountApi } from "../../../../redux/slices/totalCount/totalCountApi";
import { formatCurrency } from "../../../../utils/stringUtils";

const KpiViewModal = ({ isOpen, onClose, data }) => {
  const dispatch = useDispatch();
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {},
  );

  const rows = [
    {
      id: 1,
      uiid: 541,
      invoiceDate: "02/02/2026",
      transactionType: "Invoice",
      number: "16946",
      name: "NTT DATA Service Federal Gov.",
      memo: "Ravindra Rao (01/01/2026)",
      dueDate: "03/04/2026",
      amount: "19,950.00",
      openingBalance: "19,950.00",
    },
    {
      id: 2,
      uiid: 542,
      invoiceDate: "02/05/2026",
      transactionType: "Invoice",
      number: "16942",
      name: "Accenture LLP",
      memo: "Michael Scott (01/15/2026)",
      dueDate: "03/07/2026",
      amount: "12,500.00",
      openingBalance: "12,500.00",
    },
    {
      id: 3,
      uiid: 543,
      invoiceDate: "02/08/2026",
      transactionType: "Bill",
      number: "16951",
      name: "Deloitte Consulting",
      memo: "Sarah Johnson (01/20/2026)",
      dueDate: "03/10/2026",
      amount: "8,750.00",
      openingBalance: "8,750.00",
    },
    {
      id: 4,
      uiid: 544,
      invoiceDate: "02/10/2026",
      transactionType: "Invoice",
      number: "16950",
      name: "Infosys Ltd.",
      memo: "David Miller (01/25/2026)",
      dueDate: "03/12/2026",
      amount: "22,300.00",
      openingBalance: "22,300.00",
    },
    {
      id: 5,
      uiid: 545,
      invoiceDate: "02/12/2026",
      transactionType: "Credit Note",
      number: "16949",
      name: "Capgemini America",
      memo: "Emily Davis (01/28/2026)",
      dueDate: "03/14/2026",
      amount: "-3,200.00",
      openingBalance: "-3,200.00",
    },
    {
      id: 6,
      uiid: 546,
      invoiceDate: "02/15/2026",
      transactionType: "Invoice",
      number: "16948",
      name: "IBM Corporation",
      memo: "Robert Brown (02/01/2026)",
      dueDate: "03/17/2026",
      amount: "15,600.00",
      openingBalance: "15,600.00",
    },
    {
      id: 7,
      uiid: 547,
      invoiceDate: "02/18/2026",
      transactionType: "Bill",
      number: "16947",
      name: "Cognizant Technology",
      memo: "Olivia Wilson (02/05/2026)",
      dueDate: "03/20/2026",
      amount: "9,400.00",
      openingBalance: "9,400.00",
    },
    {
      id: 8,
      uiid: 548,
      invoiceDate: "02/20/2026",
      transactionType: "Invoice",
      number: "16952",
      name: "Tata Consultancy Services",
      memo: "James Anderson (02/07/2026)",
      dueDate: "03/22/2026",
      amount: "18,250.00",
      openingBalance: "18,250.00",
    },
  ];
  const columns = [
    { key: "invoiceDate", label: "Invoice Date", width: "text-nowrap!" },
    {
      key: "transactionType",
      label: "Transaction Type",
      width: "text-nowrap!",
    },
    {
      key: "number",
      label: "Number",
      width: "text-nowrap!",
      render: (row) => (
        <div
          className="text-info-500 cursor-pointer"
          onClick={(e) => {
            e.stopPropagation();
            dispatch(
              getCurrentInvoiceStart({
                filters: { uiid: { type: "NONE", value: row.uiid } },
                coll: "Invoice",
                ref: "Client Employee Placement Timesheet",
                incl: ["", "firstName lastName", "", "attachments"],
              }),
            );
            setSelectedInvoice(row?.number);
          }}
        >
          {row?.number}
        </div>
      ),
    },
    {
      key: "name",
      label: "Name",
      width: "min-w-[250px]! max-w-[300px]!",
      render: (row) => (
        <SmartTooltip
          description={row.name}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1!">{row?.name}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "memo",
      label: "Memo/ Description",
      width: "min-w-[250px]! max-w-[300px]!",
      render: (row) => (
        <SmartTooltip
          description={row.memo}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1!">{row?.memo}</div>
        </SmartTooltip>
      ),
    },
    { key: "dueDate", label: "Due Date", width: "text-nowrap!" },
    { key: "amount", label: "Amount", width: "text-nowrap!" },
    { key: "openingBalance", label: "Opening Balance", width: "text-nowrap!" },
  ];
  const mappedRows = mapTableRows(rows, columns);
  return (
    <div>
      <div className="flex gap-3">
        <Button
          size="md"
          title={"Back"}
          variant="text"
          icon={"arrow_left_alt"}
          color="black"
          className="px-0! bg-transparent!"
          onClick={onClose}
        />
      </div>
      <div className="flex-1 overflow-auto flex gap-4 p-0.5">
        <TableAdv
          showSlNo
          columns={columns}
          rows={mappedRows}
          totalCount={rows?.length}
          page={page}
          limit={limit}
          onPaginationChange={setPage}
          onLimitChange={handleLimitChange}
          toolbarRight={{
            search: true,
          }}
        />
      </div>
      <Modal
        isOpen={selectedInvoice}
        title={"Invoice Details"}
        onClose={() => setSelectedInvoice(null)}
        showCloseButton={true}
        closeOnOutsideClick={true}
        width="max-w-full"
      >
        <InvoiceDetails
          invoice={selectedInvoice}
          onBack={() => setSelectedInvoice(null)}
          removeButtonForPreview={true}
          // setReceivePayment={handleGoToReceivePayment}
        />
      </Modal>
    </div>
  );
};

export default KpiViewModal;

export const InvoiceKPICard = ({
  isOpen,
  onClose,
  data,
  cardsDuration = null,
  dataType = "",
  InvoiceKPICard,
  overviewCards = [],
}) => {
  const dispatch = useDispatch();
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [kpiData, setKpiData] = useState({
    data: [],
    totalCount: 0,
  });
  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {},
  );

  const rows = [
    {
      id: 1,
      uiid: 541,
      invoiceDate: "02/02/2026",
      transactionType: "Invoice",
      number: "16946",
      name: "NTT DATA Service Federal Gov.",
      memo: "Ravindra Rao (01/01/2026)",
      amount: "19,950.00",
      openingBalance: "19,950.00",
    },
    {
      id: 2,
      uiid: 542,
      invoiceDate: "02/05/2026",
      transactionType: "Invoice",
      number: "16942",
      name: "Accenture LLP",
      memo: "Michael Scott (01/15/2026)",
      amount: "12,500.00",
      openingBalance: "12,500.00",
    },
    {
      id: 3,
      uiid: 543,
      invoiceDate: "02/08/2026",
      transactionType: "Bill",
      number: "16951",
      name: "Deloitte Consulting",
      memo: "Sarah Johnson (01/20/2026)",
      amount: "8,750.00",
      openingBalance: "8,750.00",
    },
    {
      id: 4,
      uiid: 544,
      invoiceDate: "02/10/2026",
      transactionType: "Invoice",
      number: "16950",
      name: "Infosys Ltd.",
      memo: "David Miller (01/25/2026)",
      amount: "22,300.00",
      openingBalance: "22,300.00",
    },
    {
      id: 5,
      uiid: 545,
      invoiceDate: "02/12/2026",
      transactionType: "Credit Note",
      number: "16949",
      name: "Capgemini America",
      memo: "Emily Davis (01/28/2026)",
      amount: "-3,200.00",
      openingBalance: "-3,200.00",
    },
    {
      id: 6,
      uiid: 546,
      invoiceDate: "02/15/2026",
      transactionType: "Invoice",
      number: "16948",
      name: "IBM Corporation",
      memo: "Robert Brown (02/01/2026)",
      amount: "15,600.00",
      openingBalance: "15,600.00",
    },
    {
      id: 7,
      uiid: 547,
      invoiceDate: "02/18/2026",
      transactionType: "Bill",
      number: "16947",
      name: "Cognizant Technology",
      memo: "Olivia Wilson (02/05/2026)",
      amount: "9,400.00",
      openingBalance: "9,400.00",
    },
    {
      id: 8,
      uiid: 548,
      invoiceDate: "02/20/2026",
      transactionType: "Invoice",
      number: "16952",
      name: "Tata Consultancy Services",
      memo: "James Anderson (02/07/2026)",
      amount: "18,250.00",
      openingBalance: "18,250.00",
    },
  ];
  const columns = [
    {
      key: "invoiceNum",
      label: "Invoice Number",
      width: "text-nowrap!",
      render: (row) => (
        <div
          className="text-info-500 cursor-pointer"
          onClick={(e) => {
            e.stopPropagation();
            dispatch(
              getCurrentInvoiceStart({
                filters: { uiid: { type: "NONE", value: row.uiid } },
                coll: "Invoice",
                ref: "Client Employee Placement Timesheet",
                incl: ["", "firstName lastName", "", "attachments"],
              }),
            );
            setSelectedInvoice(row?.invoiceNum);
          }}
        >
          {row?.invoiceNum}
        </div>
      ),
    },
    {
      key: "invoiceDate",
      label: "Invoice Date",
      width: "text-nowrap!",
      render: (row) => dateFormator(row?.invoiceDate),
    },
    {
      key: "dueDate",
      label: "Due Date",
      width: "text-nowrap!",
      render: (row) => dateFormator(row?.dueDate),
    },
    // {
    //   key: "transactionType",
    //   label: "Transaction Type",
    //   width: "text-nowrap!",
    // },
    {
      key: "employeeName",
      label: "Employee Name",
      width: "text-nowrap!",
      render: (row) => (
        <SmartTooltip
          description={row?.employeeName}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1!">{row?.employeeName}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "clientName",
      label: "Client Name",
      width: "text-nowrap!",
      render: (row) => row?.clientName || "",
    },
    {
      key: "invoiced_amount",
      label: "Invoice Amount",
      width: "text-nowrap!",
      render: (row) => formatCurrency(row?.amounts?.invoiced),
    },
    {
      key: "received_amount",
      label: "Received Amount",
      width: "text-nowrap!",
      render: (row) => formatCurrency(row?.amounts?.received),
    },
    {
      key: "memo",
      label: "Memo/ Description",
      width: "text-nowrap!",
      render: (row) => (
        <SmartTooltip
          description={row.memo}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1!">{row?.memo}</div>
        </SmartTooltip>
      ),
    },
  ];
  function getMonthDateRange(month, year) {
    if (!Number.isInteger(month) || month < 1 || month > 12) {
      throw new Error("Month must be an integer between 1 and 12.");
    }
    if (!Number.isInteger(year)) {
      throw new Error("Year must be a valid integer.");
    }
    const from = new Date(Date.UTC(year, month - 1, 1, 0, 0, 0, 0));
    const to = new Date(Date.UTC(year, month, 0, 23, 59, 59, 999));
    return { from, to };
  }
  const fetchData = async () => {
    try {
      setLoading(true);
      let filters = {};
      const today = new Date();
      if (typeof dataType === "number") {
        if (!cardsDuration?.year) {
          showToast("Year is required for monthly data!", "error");
          return;
        }
        const { from, to } = getMonthDateRange(dataType, cardsDuration?.year);
        filters = {
          placementTS: { type: "AG_INVOICE_SEARCH", value: [searchValue, "all"] },
          "version.isLatest": { type: "NONE", value: true },
          invoiceDate: { type: "BETWEEN", value: [from, to] },
        };
      } else {
        switch (dataType) {
          case "All Invoices": {
            filters = {
              placementTS: { type: "AG_INVOICE_SEARCH", value: [searchValue, "all"] },
              "version.isLatest": { type: "NONE", value: true },
              ...(cardsDuration?.from && cardsDuration?.to
                ? { invoiceDate: { type: "BETWEEN", value: [cardsDuration.from, cardsDuration.to] } }
                : cardsDuration?.from
                ? { invoiceDate: { type: "GTE", value: cardsDuration.from } }
                : cardsDuration?.to
                ? { invoiceDate: { type: "LTE", value: cardsDuration.to } }
                : {}),
            };
            break;
          }
          case "Open Invoices": {
            filters = {
              placementTS: { type: "AG_INVOICE_SEARCH", value: [searchValue, "open"] },
              "version.isLatest": { type: "NONE", value: true },
              ...(cardsDuration?.from && cardsDuration?.to
                ? { invoiceDate: { type: "BETWEEN", value: [cardsDuration.from, cardsDuration.to] } }
                : cardsDuration?.from
                ? { invoiceDate: { type: "GTE", value: cardsDuration.from } }
                : cardsDuration?.to
                ? { invoiceDate: { type: "LTE", value: cardsDuration.to } }
                : {}),
            };
            break;
          }
          case "Due Invoices": {
            filters = {
              placementTS: { type: "AG_INVOICE_SEARCH", value: [searchValue, "due"] },
              "version.isLatest": { type: "NONE", value: true },
              ...(cardsDuration?.from && cardsDuration?.to
                ? { invoiceDate: { type: "BETWEEN", value: [cardsDuration.from, cardsDuration.to] } }
                : cardsDuration?.from
                ? { invoiceDate: { type: "GTE", value: cardsDuration.from } }
                : cardsDuration?.to
                ? { invoiceDate: { type: "LTE", value: cardsDuration.to } }
                : {}),
            };
            break;
          }
          case "Paid Invoices": {
            filters = {
              placementTS: { type: "AG_INVOICE_SEARCH", value: [searchValue, "paid"] },
              "version.isLatest": { type: "NONE", value: true },
              ...(cardsDuration?.from && cardsDuration?.to
                ? { invoiceDate: { type: "BETWEEN", value: [cardsDuration.from, cardsDuration.to] } }
                : cardsDuration?.from
                ? { invoiceDate: { type: "GTE", value: cardsDuration.from } }
                : cardsDuration?.to
                ? { invoiceDate: { type: "LTE", value: cardsDuration.to } }
                : {}),
            };
            break;
          }
          case "Total Funded": {
            filters = {
              placementTS: { type: "AG_INVOICE_SEARCH", value: [searchValue, "total_funded"] },
              "version.isLatest": { type: "NONE", value: true },
              ...(cardsDuration?.from && cardsDuration?.to
                ? { invoiceDate: { type: "BETWEEN", value: [cardsDuration.from, cardsDuration.to] } }
                : cardsDuration?.from
                ? { invoiceDate: { type: "GTE", value: cardsDuration.from } }
                : cardsDuration?.to
                ? { invoiceDate: { type: "LTE", value: cardsDuration.to } }
                : {}),
            };
            break;
          }
          case "Funded": {
            filters = {
              placementTS: { type: "AG_INVOICE_SEARCH", value: [searchValue, "funded"] },
              "version.isLatest": { type: "NONE", value: true },
              ...(cardsDuration?.from && cardsDuration?.to
                ? { invoiceDate: { type: "BETWEEN", value: [cardsDuration.from, cardsDuration.to] } }
                : cardsDuration?.from
                ? { invoiceDate: { type: "GTE", value: cardsDuration.from } }
                : cardsDuration?.to
                ? { invoiceDate: { type: "LTE", value: cardsDuration.to } }
                : {}),
            };
            break;
          }
          case "Ready To Fund": {
            filters = {
              placementTS: { type: "AG_INVOICE_SEARCH", value: [searchValue, "ready_to_fund"] },
              "version.isLatest": { type: "NONE", value: true },
              ...(cardsDuration?.from && cardsDuration?.to
                ? { invoiceDate: { type: "BETWEEN", value: [cardsDuration.from, cardsDuration.to] } }
                : cardsDuration?.from
                ? { invoiceDate: { type: "GTE", value: cardsDuration.from } }
                : cardsDuration?.to
                ? { invoiceDate: { type: "LTE", value: cardsDuration.to } }
                : {}),
            };
            break;
          }
          case "Rejected for Funding": {
            filters = {
              placementTS: { type: "AG_INVOICE_SEARCH", value: [searchValue, "rejected_funding"] },
              "version.isLatest": { type: "NONE", value: true },
              ...(cardsDuration?.from && cardsDuration?.to
                ? { invoiceDate: { type: "BETWEEN", value: [cardsDuration.from, cardsDuration.to] } }
                : cardsDuration?.from
                ? { invoiceDate: { type: "GTE", value: cardsDuration.from } }
                : cardsDuration?.to
                ? { invoiceDate: { type: "LTE", value: cardsDuration.to } }
                : {}),
            };
            break;
          }
          default: {
            showToast("Something Went Wrong!", "error");
            return;
          }
        }
      }

      const params = {
        coll: "Invoice",
        filters,
        limit: limit,
        page: page,
        ref: "Employee Client",
        useAggregate: true,
        collection: "invoices",
        ret: "invoiceNum amounts clientId employeeId uiid invoiceDate dueDate memo qbSync",
        incl: ["firstName lastName", "businessName"],
      };
      const response = await fetchAllInvoices(params);
      // When using AG_INVOICE_SEARCH aggregate, the response contains both data and total count
      const aggregateData = response?.data?.data?.[0]?.data || [];
      const aggregateTotal = response?.data?.data?.[0]?.total?.[0]?.count || 0;

      setKpiData({
        data: aggregateData,
        totalCount: aggregateTotal,
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, limit, dataType, searchValue, cardsDuration, overviewCards]);

  const totalDisplayValue = typeof dataType === "number" 
    ? (overviewCards?.find((item) => item.month === dataType)?.revenue || 0)
    : (overviewCards?.find((item) => item.title === dataType)?.value || 0);

  const mappedRows = mapTableRows(kpiData?.data || [], columns);
  return (
    <div>
      <div className="flex gap-3 justify-between mt-4">
        <Button
          size="md"
          title={"Back"}
          variant="text"
          icon={"arrow_left_alt"}
          color="black"
          className="px-0! bg-transparent!"
          onClick={onClose}
        />
        {<div className="pr-4">
          {/* <InfoCardNewAdv title={totalDisplay.label} value={formatCurrency(totalDisplay.value)} />*/}
          <InfoCardNewAdv title={"Total Amount"} value={totalDisplayValue} />
        </div>}
      </div>
      <div className="hidden gap-3">
        Total Invoiced{" "}
        {kpiData?.data?.reduce((acc, curr) => acc + curr.amounts.invoiced, 0)}
        <br />
        Total Received{" "}
        {kpiData?.data?.reduce((acc, curr) => acc + curr.amounts.received, 0)}
        <br />
        Total Due{" "}
        {kpiData?.data?.reduce((acc, curr) => acc + curr.amounts.due, 0)}
        <br />
      </div>
      <div className="flex-1 overflow-auto flex gap-4 p-0.5">
        <TableAdv
          showSlNo
          columns={columns}
          rows={mappedRows}
          totalCount={kpiData?.totalCount || 0}
          serverPagination={true}
          page={page}
          limit={limit}
          onPaginationChange={setPage}
          onLimitChange={handleLimitChange}
          toolbarRight={{
            search: true,
          }}
          serverSearchValue={searchValue}
          serverOnSearch={(key, val) => {
            setSearchValue(val);
            setPage(1);
          }}
        />
      </div>
      <Modal
        isOpen={selectedInvoice}
        title={"Invoice Details"}
        onClose={() => setSelectedInvoice(null)}
        showCloseButton={true}
        closeOnOutsideClick={true}
        width="max-w-full"
      >
        <InvoiceDetails
          invoice={selectedInvoice}
          onBack={() => setSelectedInvoice(null)}
          removeButtonForPreview={true}
          // setReceivePayment={handleGoToReceivePayment}
        />
      </Modal>
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};
